(() => {
  const section=document.getElementById('SlkMatchingAccessories');
  const endpoint=section?.dataset.analyticsEndpoint;
  if(!endpoint||window.Shopify?.designMode||new URLSearchParams(location.search).has('preview_theme_id'))return;
  const key='slk-matching-visit-v1',ttl=30*60*1000;
  let acknowledged=null,visible=false,timer=null,pending=false;
  const permitted=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;
  function visit(){
    if(!permitted())return null;
    try{const old=JSON.parse(localStorage.getItem(key)||'null');
      if(old&&Date.now()-old.started<ttl&&/^[a-f0-9-]{36}$/.test(old.id))return old;
      const next={id:crypto.randomUUID(),started:Date.now()};localStorage.setItem(key,JSON.stringify(next));return next;
    }catch{return null;}
  }
  async function send(kind,v){
    const r=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({kind,visit:v.id,started:v.started,source:section.dataset.productId}),credentials:'omit',keepalive:true,signal:AbortSignal.timeout(4000)});
    if(!r.ok)throw Error('Event unavailable');
  }
  async function expose(){
    if(!visible||document.visibilityState!=='visible'||!permitted()||pending)return;
    const v=visit();if(!v||acknowledged?.id===v.id)return;
    pending=true;try{await send('view',v);if(permitted())acknowledged=v;}catch{}finally{pending=false;}
  }
  function schedule(){clearTimeout(timer);if(visible&&permitted()&&document.visibilityState==='visible')timer=setTimeout(expose,1000);}
  // Count a real product card, not the hidden section or a heading alone.
  const observed=new Set(),inView=new Set();
  const observer=new IntersectionObserver(entries=>{
    for(const e of entries){if(e.intersectionRatio>=0.5&&!e.target.hidden)inView.add(e.target);else inView.delete(e.target);}
    visible=inView.size>0&&!section.hidden;schedule();
  },{threshold:[0,0.5]});
  const observe=()=>{for(const card of section.querySelectorAll('[data-matching-product]'))if(!observed.has(card)){observed.add(card);observer.observe(card);}};
  new MutationObserver(observe).observe(section,{childList:true,subtree:true});observe();
  document.addEventListener('visibilitychange',schedule);
  document.addEventListener('visitorConsentCollected',()=>{
    if(!permitted()){acknowledged=null;clearTimeout(timer);try{localStorage.removeItem(key);}catch{}}
    else schedule();
  });
  if(!window.Shopify?.customerPrivacy)window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)schedule();});
  document.addEventListener('formdata',event=>{
    if(!event.target.closest?.('[data-matching-product]'))return;
    event.formData.delete('properties[_slk_visit]');
    if(permitted()&&acknowledged&&Date.now()-acknowledged.started<ttl)event.formData.set('properties[_slk_visit]',acknowledged.id);
  },true);
  const original=window.SlkMatchingAccessories?.afterAdd;
  if(original)window.SlkMatchingAccessories.afterAdd=async function(product,form,cart){
    const result=await original.call(this,product,form,cart);
    if(result&&form.closest('[data-matching-product]')&&permitted()&&acknowledged&&Date.now()-acknowledged.started<ttl)send('add',acknowledged).catch(()=>{});
    return result;
  };
})();
